import { PUBLIC_AVATAR_URL, PUBLIC_FIRE_URL } from "../constants/publicAssets";
import { useBonusBalance } from "../hooks/useBonusBalance";
import { useAuthUser } from "../hooks/useTelegram";

function getTelegramIdFromWebApp() {
  if (typeof window === "undefined") return null;
  const id = window.Telegram?.WebApp?.initDataUnsafe?.user?.id;
  if (typeof id === "number" && Number.isFinite(id)) return id;
  if (typeof id === "string" && /^\d+$/.test(id)) return Number(id);
  return null;
}

/**
 * Матовая полоса: бренд и приветствие слева, баланс бонусов справа (тап — экран бонусов).
 */
export function AppChrome({ onOpenBonuses, balanceSyncKey }) {
  const { balance } = useBonusBalance(balanceSyncKey);
  const n = Math.round(Number(balance) || 0);
  const authUser = useAuthUser();
  const greetingName = authUser?.first_name?.trim() || "Гость";
  const telegramId = authUser?.telegram_id ?? getTelegramIdFromWebApp();

  return (
    <header className="appChrome" role="banner">
      <div className="appChrome__topRow">
        <div className="appChrome__brand">
          <div className="appChrome__greetingRow">
            <div className="appChrome__avatarGlow" aria-hidden>
              <div className="appChrome__avatar">
                <img
                  className="appChrome__avatarImg"
                  src={PUBLIC_AVATAR_URL}
                  alt=""
                  width={64}
                  height={64}
                  decoding="async"
                />
              </div>
            </div>
            <div className="appChrome__greetingSep" aria-hidden />
            <div className="appChrome__greetingCol">
              <p className="appChrome__greeting">
                Привет, <span className="appChrome__greetingName">{greetingName}</span> !
              </p>
              {telegramId != null ? (
                <p className="appChrome__telegramId">ID {telegramId}</p>
              ) : null}
            </div>
          </div>
        </div>
        <div className="appChrome__actions">
          <button
            type="button"
            className="appChrome__bonusPill"
            onClick={onOpenBonuses}
            aria-label={`Бонусы: ${n}`}
          >
            <span className="appChrome__bonusValue">{n}</span>
            <span className="appChrome__bonusUnit" aria-hidden>
              <img className="appChrome__bonusIcon" src={PUBLIC_FIRE_URL} alt="" width={12} height={12} />
            </span>
          </button>
        </div>
      </div>
      <button
        type="button"
        className="appChrome__bonusEntry"
        onClick={onOpenBonuses}
        aria-label="Открыть QR-коды и бонусы"
      >
        ПРОФИЛЬ, БАЛАНС, ИСТОРИЯ, QR
      </button>
    </header>
  );
}
